import { AttachingMethod, AttachmentType } from '../../../types';
import { AttachmentErrorType } from '../../common/reducers/types';

export type BiAttachment = {
  file_name: string;
  file_size: number;
  file_type: string | null; // null in case if file type is not supported(when error appears)
};

export const attachmentTypeMapper: Record<AttachmentType, string> = {
  [AttachmentType.Image]: 'image',
  [AttachmentType.Video]: 'video',
};

export const attachingMethodMapper: Record<AttachingMethod, string> = {
  [AttachingMethod.Button]: 'button',
  [AttachingMethod.Drop]: 'drop',
  [AttachingMethod.Paste]: 'paste',
};

export const attachmentErrorTypeMapper: Record<AttachmentErrorType, string> = {
  [AttachmentErrorType.Network]: 'network',
  [AttachmentErrorType.FilesLimit]: 'files limit',
  [AttachmentErrorType.FileType]: 'file type',
  [AttachmentErrorType.FileSize]: 'file size',
};
